import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import ColorBox from "component/design-system/color-box/ColorBox";
import { TriangleAlert } from "lucide-react";
import styles from "./stockLabel.module.scss";

function StockLabel(props: any) {
  const { t } = useTranslation("common");
  const { outOfStock, limitedQuantityDetails } = props;
  if (outOfStock) {
    return (
      <ColorBox color="red">
        <PAText component="span" color="alert-text" fontSize={FONT_SIZE[0]}>
          <strong>{t("SOLD OUT")}</strong>
          <PAText color="black" fontSize={FONT_SIZE[0]}>
            {` - ${t("sold_out_help")}`}
          </PAText>
        </PAText>
      </ColorBox>
    );
  }
  // https://dev.partsavatar.ca/mirror-ho1321216
  if (limitedQuantityDetails && limitedQuantityDetails.limitedQuantity) {
    return (
      <ColorBox color="warning-yellow">
        <TriangleAlert color="#ff9800" size={15} />
        <h5 className={styles.limited_stock}>
          <strong className={styles.limited_stock_label}>
            {t("LIMITED STOCK")}
            &nbsp;
            {t("limited_stock_help", { quantity: limitedQuantityDetails.quantity })}
          </strong>
        </h5>
      </ColorBox>
    );
  }
  return null;
  // return (
  //   <PAText component="span" size={FONT_SIZE[2]} className="color-green bold in-stock">{t("IN STOCK - ONLINE")}</PAText>
  // );
}

export default StockLabel;
